import SelectField from "@/components/common/select";
import { Icon } from "@elaniintc/goes-design-system";
import { DataCenterDataSelect } from "@/pages/digital-files/components/DataCenterDataSelect";
import type { RenderFieldContext } from "./types";

export function renderSelectOptionsRoot({
  fieldConfig,
  formValues,
  updateFormValue,
}: RenderFieldContext) {
  const labelSuffix = fieldConfig.customProps?.labelSuffix;
  const isSearchable = fieldConfig.customProps?.searchable === true;
  const optionsRootSource = formValues["options_root_source"];
  let localList: string[] = [];
  let databaseConfig: { table: string; column: string } | undefined;

  if (optionsRootSource === "manual") {
    const vals = formValues["options_root_list"];
    localList =
      vals &&
      Array.isArray(vals) &&
      vals.length > 0 &&
      typeof vals[0] === "string"
        ? (vals as string[])
        : [];
  } else {
    const table = formValues["options_root_datacenter_table"];
    const column = formValues["options_root_datacenter_column"];
    if (
      table &&
      column &&
      typeof table === "string" &&
      typeof column === "string"
    ) {
      databaseConfig = { table, column };
    }
  }

  return (
    <DataCenterDataSelect
      key={fieldConfig.key}
      name={fieldConfig.key}
      label={fieldConfig.label}
      placeholder={fieldConfig.placeholder ?? "Selecciona una opción"}
      required={fieldConfig.required}
      helperText={fieldConfig.helperText}
      labelHelperText={labelSuffix}
      enableSearch={isSearchable && !!databaseConfig}
      initOptions={localList}
      database={databaseConfig}
      value={formValues[fieldConfig.key] as string}
      onChange={(val: { key: string; label: string }) =>
        updateFormValue(fieldConfig.key, val.key)
      }
    />
  );
}

export function renderSelectDropdown({
  fieldConfig,
  value,
  updateFormValue,
}: RenderFieldContext) {
  const labelSuffix = fieldConfig.customProps?.labelSuffix;
  const selectOptions = fieldConfig.options || [];
  const optionIcon = fieldConfig.customProps?.optionIcon;
  const optionIconPosition =
    fieldConfig.customProps?.optionIconPosition || "left";
  return (
    <div key={fieldConfig.key} className="flex flex-col gap-1">
      {labelSuffix ? (
        <div className="flex items-center justify-between">
          <label
            htmlFor={fieldConfig.key}
            className="font-semibold text-body-loud text-sm leading-2xl"
          >
            {fieldConfig.label}
            {fieldConfig.required && (
              <span className="text-sm text-danger ml-1">*</span>
            )}
          </label>
          <span className="text-xs text-body-quiet">{labelSuffix}</span>
        </div>
      ) : null}
      <SelectField
        name={fieldConfig.key}
        label={labelSuffix ? "" : fieldConfig.label}
        placeholder={fieldConfig.placeholder || "Selecciona una opción"}
        required={fieldConfig.required}
        value={typeof value === "string" ? value : ""}
        onChange={(newValue) => updateFormValue(fieldConfig.key, newValue)}
        options={selectOptions.map((opt) => ({
          value: opt.value,
          label: opt.label,
          icon: optionIcon ? (
            <Icon
              type="far"
              name={optionIcon}
              className="text-body-quiet text-base w-4"
            />
          ) : undefined,
          iconPosition: optionIcon ? optionIconPosition : undefined,
        }))}
        srOnlyLabel={!!labelSuffix}
      />
      {fieldConfig.helperText && (
        <p className="text-xs text-body-quiet mt-1">{fieldConfig.helperText}</p>
      )}
    </div>
  );
}

export function renderSelectField(ctx: RenderFieldContext) {
  return ctx.fieldConfig.customProps?.source === "options_root"
    ? renderSelectOptionsRoot(ctx)
    : renderSelectDropdown(ctx);
}
